import { memo, useEffect, useRef } from "react";
import { ScrollArea } from "../components/ui/scroll-area";
import { ArticleHeader } from "./ArticleHeader";
import { ArticleBody } from "./ArticleBody";
import { ArticleFooter } from "./ArticleFooter";

function EmptyState() {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-12" data-testid="article-reader-empty">
      <div className="mb-6 w-64 h-40 bg-gray-100 dark:bg-zinc-900 flex items-center justify-center">
        <svg className="w-16 h-16 text-gray-300 dark:text-zinc-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      </div>
      <p className="text-xs tracking-[0.2em] uppercase font-mono text-gray-400 mb-2">
        Vælg en artikel
      </p>
      <p className="text-[10px] font-mono text-gray-300 dark:text-gray-400">
        Klik på en nyhed i feedet for at læse den
      </p>
    </div>
  );
}

export const ArticleReader = memo(function ArticleReader({ article }) {
  const scrollAreaRef = useRef(null);

  useEffect(() => {
    scrollAreaRef.current?.scrollTo({ top: 0, left: 0 });
  }, [article?.id]);

  if (!article) return <EmptyState />;

  return (
    <ScrollArea ref={scrollAreaRef}>
      <div className="p-5 sm:p-8 lg:p-12 max-w-3xl" data-testid="article-reader">
        <ArticleHeader article={article} />
        <ArticleBody article={article} />
        <ArticleFooter article={article} />
      </div>
    </ScrollArea>
  );
});
